export interface HistoryEntry {
  id: string;
  type: 'radio' | 'programa' | 'video' | 'podcast' | 'evento' | 'concurso' | 'saludo' | 'cancion';
  timestamp: string;
  title: string;
  subtitle: string;
  description: string;
  metadata?: string;
  image?: string;
  hasDetail?: boolean;
  targetPath?: string;
}

export const historyEntries: HistoryEntry[] = [
  // ── HOY ──
  {
    id: 'h01',
    type: 'radio',
    timestamp: new Date(Date.now() - 10 * 60 * 1000).toISOString(),
    title: 'Radio Éxito',
    subtitle: 'Pop Latino · Escuchaste 45 min',
    description: 'Sintonizaste Radio Éxito durante el programa "Pop sin Filtro" con María José Ruiz.',
    metadata: 'Desde las 10:05 AM',
    image: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20minimalist%20sound%20wave%20design%20warm%20coral%20and%20cream%20gradient%20clean%20geometric%20abstract%20composition%20studio%20branding%20identity&width=128&height=128&seq=hist-exito-01&orientation=squarish',
    hasDetail: true,
  },
  {
    id: 'h02',
    type: 'programa',
    timestamp: new Date(Date.now() - 35 * 60 * 1000).toISOString(),
    title: 'Éxitos de la Mañana',
    subtitle: 'Radio Éxito · Carlos Mendoza y Ana Vega',
    description: 'Viste el programa matutino. Hoy entrevistaron a Shakira y regalaron entradas para su concierto.',
    metadata: '6:00 - 10:00 AM',
    image: 'https://readdy.ai/api/search-image?query=Morning%20radio%20show%20branding%20logo%20warm%20sunrise%20orange%20and%20yellow%20minimalist%20design%20clean%20geometric%20sun%20icon%20studio%20identity&width=128&height=128&seq=hist-prog-manana&orientation=squarish',
    hasDetail: true,
  },
  {
    id: 'h03',
    type: 'cancion',
    timestamp: new Date(Date.now() - 50 * 60 * 1000).toISOString(),
    title: 'TQG',
    subtitle: 'Karol G & Shakira · Solicitada en Radio Ritmo',
    description: 'Solicitaste esta canción en "Ritmo Urbano". DJ Lúcido la puso al aire y te dio un saludo.',
    metadata: 'Dedicada a: "Para toda la comunidad RFW"',
    hasDetail: false,
  },
  {
    id: 'h04',
    type: 'saludo',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    title: 'Saludo al aire',
    subtitle: 'Enviado a "Éxitos de la Mañana" · Radio Éxito',
    description: '"Buenos días desde Montevideo, los escucho todos los días! Arriba RFW!" — Tu saludo fue leído al aire por Carlos Mendoza.',
    metadata: 'Respuesta del locutor: "Gracias Marco, un abrazo grande a Uruguay"',
    hasDetail: false,
  },
  {
    id: 'h05',
    type: 'radio',
    timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    title: 'RFW Noticias',
    subtitle: 'Noticias · Escuchaste 30 min',
    description: 'Sintonizaste el informativo matutino con Laura Fernández para estar al día.',
    metadata: 'Desde las 8:00 AM',
    image: 'https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%20minimalist%20clean%20navy%20and%20silver%20design%20geometric%20abstract%20globe%20shape%20professional%20broadcasting%20branding%20identity&width=128&height=128&seq=hist-noticias-01&orientation=squarish',
    hasDetail: true,
  },

  // ── AYER ──
  {
    id: 'h06',
    type: 'concurso',
    timestamp: new Date(Date.now() - 25 * 60 * 60 * 1000).toISOString(),
    title: 'Trivia del Día',
    subtitle: 'Radio Éxito · ¡Ganaste!',
    description: 'Participaste en la trivia diaria de "Pop sin Filtro". Respondiste correctamente las 3 preguntas y ganaste 150 puntos.',
    metadata: 'Premio: 150 pts + entrada a sorteo semanal',
    hasDetail: true,
  },
  {
    id: 'h07',
    type: 'programa',
    timestamp: new Date(Date.now() - 26 * 60 * 60 * 1000).toISOString(),
    title: 'Ritmo Urbano',
    subtitle: 'Radio Ritmo · DJ Lúcido',
    description: 'Viste el programa de la tarde. Bloque especial de reggaetón old school con los clásicos de Daddy Yankee y Don Omar.',
    metadata: '2:00 - 6:00 PM',
    image: 'https://readdy.ai/api/search-image?query=Urban%20radio%20show%20branding%20logo%20bold%20emerald%20green%20and%20black%20minimalist%20design%20clean%20geometric%20abstract%20sound%20block%20studio%20identity&width=128&height=128&seq=hist-prog-urbano&orientation=squarish',
    hasDetail: true,
  },
  {
    id: 'h08',
    type: 'cancion',
    timestamp: new Date(Date.now() - 27 * 60 * 60 * 1000).toISOString(),
    title: 'Gasolina',
    subtitle: 'Daddy Yankee · Solicitada en Radio Ritmo',
    description: 'Solicitaste este clásico en "Ritmo Urbano". La pusieron en el bloque old school.',
    metadata: 'Dedicada a: "A todos los que crecieron con este temazo"',
    hasDetail: false,
  },
  {
    id: 'h09',
    type: 'radio',
    timestamp: new Date(Date.now() - 28 * 60 * 60 * 1000).toISOString(),
    title: 'ElectroBeat',
    subtitle: 'Electrónica · Escuchaste 1h 20min',
    description: 'Sintonizaste ElectroBeat para relajarte con las sesiones deep house de la tarde.',
    metadata: 'Desde las 4:30 PM',
    image: 'https://readdy.ai/api/search-image?query=Electronic%20music%20radio%20station%20logo%20minimalist%20neon%20violet%20and%20cyan%20design%20abstract%20sound%20wave%20grid%20broadcasting%20branding%20clean%20identity&width=128&height=128&seq=hist-electro-01&orientation=squarish',
    hasDetail: true,
  },

  // ── HACE 3 DÍAS ──
  {
    id: 'h10',
    type: 'evento',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    title: 'Fiesta Latina 2026',
    subtitle: 'Evento RFW · Modalidad virtual',
    description: 'Asististe al evento virtual de RadioFrecuenciaWeb. DJ sets en vivo, sorteos y meet & greet con los locutores de la red.',
    metadata: 'Participaron 2,300 oyentes · Ganaste 500 pts',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20latin%20music%20festival%20event%20branding%20poster%20design%20warm%20tropical%20colors%20neon%20lights%20crowd%20energy%20festive%20atmosphere%20editorial%20style&width=128&height=128&seq=hist-evento-latina&orientation=squarish',
    hasDetail: true,
  },
  {
    id: 'h11',
    type: 'saludo',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000 + 2 * 60 * 60 * 1000).toISOString(),
    title: 'Saludo en vivo',
    subtitle: 'Durante "Fiesta Latina 2026" · Evento virtual',
    description: '"Vamos RFW! Saludando desde Uruguay, el mejor evento del año!" — Tu mensaje apareció en la pantalla gigante del stream.',
    metadata: '+100 pts por participación',
    hasDetail: false,
  },

  // ── HACE 5 DÍAS ──
  {
    id: 'h12',
    type: 'concurso',
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    title: 'Adivina la Canción',
    subtitle: 'La Clásica · 2do lugar',
    description: 'Participaste en el concurso de adivinar canciones de los 80s. Acertaste 8 de 10 y quedaste en 2do lugar.',
    metadata: 'Premio: 200 pts + insignia digital',
    hasDetail: true,
  },
  {
    id: 'h13',
    type: 'radio',
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000 + 3 * 60 * 60 * 1000).toISOString(),
    title: 'La Clásica',
    subtitle: 'Clásicos 80s/90s · Escuchaste 2h',
    description: 'Tarde de clásicos con Roberto Castillo. Especial de los 80s con Michael Jackson, Madonna y Queen.',
    metadata: 'Desde las 6:00 PM',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20radio%20station%20logo%20elegant%20cream%20and%20burgundy%20design%20minimalist%20shield%20shape%20broadcasting%20branding%20clean%20studio%20identity&width=128&height=128&seq=hist-clasica-01&orientation=squarish',
    hasDetail: true,
  },

  // ── HACE 1 SEMANA ──
  {
    id: 'h14',
    type: 'programa',
    timestamp: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    title: 'Deep Sessions',
    subtitle: 'ElectroBeat · DJ Nova',
    description: 'Noche de deep house. Set especial de 4 horas con tracks underground y visuales en vivo por el stream.',
    metadata: '10:00 PM - 2:00 AM',
    image: 'https://readdy.ai/api/search-image?query=Deep%20house%20radio%20show%20logo%20minimalist%20violet%20gradient%20and%20dark%20indigo%20design%20clean%20abstract%20wave%20studio%20branding%20identity&width=128&height=128&seq=hist-prog-deep&orientation=squarish',
    hasDetail: true,
  },
  {
    id: 'h15',
    type: 'cancion',
    timestamp: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000 + 1 * 60 * 60 * 1000).toISOString(),
    title: 'Innerbloom',
    subtitle: 'RÜFÜS DU SOL · Solicitada en ElectroBeat',
    description: 'Pediste este clásico del deep house. DJ Nova lo mezcló en su set de la noche.',
    metadata: 'Dedicada a: "Para cerrar la noche con este himno"',
    hasDetail: false,
  },
  {
    id: 'h16',
    type: 'saludo',
    timestamp: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000 + 30 * 60 * 1000).toISOString(),
    title: 'Mensaje en el chat',
    subtitle: 'Deep Sessions · ElectroBeat',
    description: '"DJ Nova, sos lo más! Saludos desde Uruguay, acá son las 11 PM y no me pierdo tu set ni una semana."',
    metadata: 'El chat estaba activo con 450 oyentes',
    hasDetail: false,
  },

  // ── HACE 10 DÍAS ──
  {
    id: 'h17',
    type: 'evento',
    timestamp: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    title: 'Lanzamiento Temporada 2',
    subtitle: 'RFW Presenta · Evento especial',
    description: 'Evento de lanzamiento de la nueva temporada de programación. Nuevos shows, locutores y sorpresas para la comunidad.',
    metadata: 'Asistieron 5,100 oyentes · Nuevos programas anunciados',
    image: 'https://readdy.ai/api/search-image?query=Modern%20radio%20network%20season%20launch%20event%20branding%20poster%20design%20warm%20spotlight%20stage%20microphone%20neon%20accents%20excitement%20editorial%20photography%20style&width=128&height=128&seq=hist-evento-temporada&orientation=squarish',
    hasDetail: true,
  },
  {
    id: 'h18',
    type: 'concurso',
    timestamp: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000).toISOString(),
    title: 'Crea tu Playlist',
    subtitle: 'RFW Noticias · Participación',
    description: 'Armaste una playlist de 10 canciones para el segmento musical del informativo. Tu playlist fue seleccionada y salió al aire.',
    metadata: 'Tu playlist: "Noticias con Ritmo" · 300 pts',
    hasDetail: true,
  },

  // ── HACE 2 SEMANAS ──
  {
    id: 'h19',
    type: 'radio',
    timestamp: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    title: 'Radio Ritmo',
    subtitle: 'Reggaetón y Urbano · Escuchaste 3h',
    description: 'Maratón de Radio Ritmo un sábado completo. De fondo mientras hacías el asado.',
    metadata: 'Desde las 12:00 PM',
    image: 'https://readdy.ai/api/search-image?query=Radio%20station%20brand%20logo%20abstract%20rhythm%20wave%20design%20emerald%20green%20and%20gold%20gradient%20minimalist%20geometric%20clean%20broadcasting%20identity&width=128&height=128&seq=hist-ritmo-01&orientation=squarish',
    hasDetail: true,
  },
  {
    id: 'h20',
    type: 'programa',
    timestamp: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000 + 4 * 60 * 60 * 1000).toISOString(),
    title: 'Clásicos de Oro',
    subtitle: 'La Clásica · Roberto Castillo',
    description: 'Programa vespertino de clásicos. Especial de rock argentino con Soda Stereo, Charly García y Fito Páez.',
    metadata: '6:00 - 8:00 PM',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20golden%20classics%20radio%20show%20logo%20warm%20amber%20and%20brown%20minimalist%20design%20retro%20vinyl%20record%20icon%20clean%20studio%20branding&width=128&height=128&seq=hist-prog-clasicos&orientation=squarish',
    hasDetail: true,
  },

  // ── VIDEOS VISTOS ──
  {
    id: 'hv01',
    type: 'video',
    timestamp: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    title: 'Ganador del Concurso de Talentos',
    subtitle: 'Cover de Bailando · Diego Vargas · 45K vistas',
    description: 'Viste el clip más viral de RFW. Diego Vargas ganó el Concurso de Talentos con este cover acústico.',
    metadata: 'Visto 80%',
    image: 'https://readdy.ai/api/search-image?query=Young%20musician%20performing%20acoustic%20guitar%20cover%20in%20radio%20studio%2C%20warm%20spotlight%20on%20performer%2C%20microphone%20on%20stand%2C%20intimate%20performance%20atmosphere%2C%20golden%20hour%20lighting%2C%20emotional%20music%20moment%2C%20editorial%20concert%20photography&width=128&height=128&seq=hist-vid-talento&orientation=squarish',
    hasDetail: true,
    targetPath: '/tv-app/video/3',
  },
  {
    id: 'hv02',
    type: 'video',
    timestamp: new Date(Date.now() - 45 * 60 * 1000).toISOString(),
    title: 'Batalla de Locutores',
    subtitle: 'Diego Montenegro vs Andrés Castillo · 22K vistas',
    description: 'Los dos locutores más carismáticos del dial RFW cara a cara. Anécdotas, imitaciones y un cover en vivo.',
    metadata: 'Visto 45%',
    image: 'https://readdy.ai/api/search-image?query=Two%20charismatic%20radio%20hosts%20in%20energetic%20studio%20conversation%2C%20both%20laughing%20and%20gesturing%2C%20colorful%20neon%20studio%20lighting%2C%20microphones%20between%20them%2C%20fun%20competitive%20atmosphere%2C%20candid%20broadcast%20photography&width=128&height=128&seq=hist-vid-batalla&orientation=squarish',
    hasDetail: true,
    targetPath: '/tv-app/video/2',
  },
  {
    id: 'hv03',
    type: 'video',
    timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    title: 'El Fail Más Divertido',
    subtitle: 'Diego Montenegro en offside · 32K vistas',
    description: 'Diego Montenegro se equivocó de canción al aire. Quince segundos de risa genuina que se volvieron virales.',
    metadata: 'Visto completo',
    image: 'https://readdy.ai/api/search-image?query=Radio%20host%20laughing%20at%20own%20mistake%20in%20studio%2C%20hand%20covering%20face%20in%20embarrassment%2C%20colorful%20neon%20studio%20lighting%2C%20funny%20candid%20moment%2C%20authentic%20broadcast%20blooper%20photography&width=128&height=128&seq=hist-vid-fail&orientation=squarish',
    hasDetail: true,
    targetPath: '/tv-app/video/17',
  },
  {
    id: 'hv04',
    type: 'video',
    timestamp: new Date(Date.now() - 28 * 60 * 60 * 1000).toISOString(),
    title: '20 Años en la Radio',
    subtitle: 'Carlos Mendoza · 31K vistas',
    description: 'Carlos Mendoza recibió un audio sorpresa de su primer oyente. Su reacción con lágrimas es uno de los momentos más genuinos de RFW.',
    metadata: 'Visto 60%',
    image: 'https://readdy.ai/api/search-image?query=Veteran%20radio%20host%20emotional%20moment%20in%20warm%20studio%2C%20wall%20of%20career%20memorabilia%2C%20golden%20anniversary%20decorations%2C%20genuine%20tears%20of%20joy%2C%20heartfelt%20nostalgic%20atmosphere%2C%20documentary%20photography%20style&width=128&height=128&seq=hist-vid-20anos&orientation=squarish',
    hasDetail: true,
    targetPath: '/tv-app/video/10',
  },
  {
    id: 'hv05',
    type: 'podcast',
    timestamp: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    title: 'Modo Creativo — Episodio 42',
    subtitle: 'Diego Quintero · Gaming y tecnología',
    description: 'Escuchaste el episodio sobre el futuro del streaming. Entrevista exclusiva con un desarrollador de Unreal Engine 6.',
    metadata: 'Escuchado 75%',
    image: 'https://readdy.ai/api/search-image?query=Modern%20gaming%20and%20tech%20podcast%20studio%20with%20RGB%20LED%20strips%2C%20multiple%20monitors%20displaying%20game%20streams%2C%20neon%20gaming%20peripherals%2C%20fun%20colorful%20aesthetic%2C%20youthful%20energetic%20broadcast%20atmosphere%2C%20editorial%20photography%20with%20cyberpunk-inspired%20lighting&width=128&height=128&seq=hist-pod-modo&orientation=squarish',
    hasDetail: true,
    targetPath: '/tv-app/podcast/7',
  },
  {
    id: 'hv06',
    type: 'podcast',
    timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    title: 'Conversaciones Reales — Episodio 18',
    subtitle: 'Carolina Vega · Salud mental',
    description: 'Episodio sobre ansiedad en la era digital. La Dra. Vega compartió herramientas prácticas que aplicaste ese mismo día.',
    metadata: 'Escuchado completo',
    image: 'https://readdy.ai/api/search-image?query=Intimate%20warm%20radio%20studio%20atmosphere%20with%20soft%20amber%20lighting%2C%20comfortable%20armchairs%20facing%20each%20other%2C%20acoustic%20panels%20on%20walls%2C%20plants%20for%20a%20calming%20environment%2C%20gentle%20candle-like%20warm%20glow%2C%20editorial%20photography%20with%20emotional%20depth%20and%20safe%20space%20aesthetic&width=128&height=128&seq=hist-pod-conversaciones&orientation=squarish',
    hasDetail: true,
    targetPath: '/tv-app/podcast/4',
  },
  {
    id: 'hv07',
    type: 'video',
    timestamp: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    title: 'El Gol que Hizo Gritar a Todo un País',
    subtitle: 'Javier Solís · Deportes Total Radio · 38K vistas',
    description: 'La narración del gol de la final del campeonato nacional. El rugido de la multitud y la emoción en la voz del narrador.',
    metadata: 'Visto completo',
    image: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20panoramic%20view%20during%20championship%20final%20goal%20moment%2C%20packed%20crowd%20with%20team%20colors%20erupting%20in%20celebration%2C%20dramatic%20stadium%20lighting%20at%20dusk%2C%20broadcast%20commentary%20booth%20overlooking%20the%20field%2C%20intense%20sports%20atmosphere%2C%20professional%20sports%20photography&width=128&height=128&seq=hist-vid-gol&orientation=squarish',
    hasDetail: true,
    targetPath: '/tv-app/video/4',
  },
  {
    id: 'hv08',
    type: 'podcast',
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    title: 'Finanzas al Aire — Episodio 55',
    subtitle: 'Mariana Duarte · Inversiones para principiantes',
    description: 'Aprendiste sobre fondos indexados y abriste tu primera cuenta de inversión después de escuchar este episodio.',
    metadata: 'Escuchado 90%',
    image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20financial%20podcast%20studio%20with%20minimalist%20design%2C%20stock%20market%20charts%20on%20screens%2C%20white%20and%20sage%20green%20color%20palette%2C%20natural%20daylight%20through%20large%20windows%2C%20professional%20yet%20approachable%20atmosphere%2C%20editorial%20photography%20with%20fresh%20morning%20aesthetic&width=128&height=128&seq=hist-pod-finanzas&orientation=squarish',
    hasDetail: true,
    targetPath: '/tv-app/podcast/10',
  },
];

export const historyStats = {
  totalEntries: 28,
  radiosCount: 5,
  programasCount: 4,
  videosCount: 5,
  podcastsCount: 3,
  eventosCount: 2,
  concursosCount: 3,
  saludosCount: 3,
  cancionesCount: 3,
  last7Days: 21,
  totalPointsEarned: 1250,
};